import React from 'react';

export const EmptySquare = ({ number }: { number: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <path
      d="M49.425 1.83736L62.1761 49.4252L14.5883 62.1764L1.83712 14.5885L49.425 1.83736Z"
      fill="white"
      stroke="#044D29"
      strokeWidth="3"
    />
    <text
      x="32.5"
      y="32.5"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize="24"
      fontWeight="bold"
      fill="#044D29"
    >
      {number}
    </text>
  </svg>
);
